import { blue } from 'bold-ui/lib/styles/colors'
import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { SoapSection } from '../SoapSection'
import { ObjetivoForm, ObjetivoFormModel } from './ObjetivoForm'

export interface ObjetivoSectionProps {
  name: MetaPath<ObjetivoFormModel>
  cidadao: CidadaoAtendimento
  dataAtendimento: Instant
  tipoAtendProf: TipoAtendimentoProfissional
}

export function ObjetivoSection(props: ObjetivoSectionProps) {
  return (
    <SoapSection initial='O' title='Objetivo' color={blue}>
      <ObjetivoForm {...props} />
    </SoapSection>
  )
}
